import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { PlanningCycleRow } from './planningCycle.models';

type Props = {
  rows: PlanningCycleRow[];
  loading?: boolean;
  onSelect: (row: PlanningCycleRow) => void;
};

class PlanningCycleGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'code', headerName: 'Cycle', width: 210 },
    { field: 'name', headerName: 'Name', flex: 1, minWidth: 260 },
    { field: 'budgetperiodcode', headerName: 'Budget Period', width: 160 },
    { field: 'fiscalyear', headerName: 'Fiscal Year', width: 110 },
    { field: 'phasecode', headerName: 'Current Phase', width: 210 },
    {
      field: 'statecode',
      headerName: 'State',
      width: 130,
      renderCell: (p) => (
        <Chip
          size="small"
          label={p.value || '-'}
          color={p.value === 'ACTIVE' ? 'success' : p.value === 'CLOSED' ? 'default' : 'warning'}
        />
      ),
    },
    { field: 'periodstartdate', headerName: 'Starts', width: 120 },
    { field: 'periodenddate', headerName: 'Ends', width: 120 },
  ];

  render() {
    return (
      <FDataGrid
        title="Planning Cycles"
        subtitle="Budget-domain planning exercises and their current lifecycle phase."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={500}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={(r: any) => r.rid}
        onRowClick={(p: any) => this.props.onSelect(p.row)}
        pageSizeOptions={[10, 25, 50]}
      />
    );
  }
}

export default PlanningCycleGrid;
